/**
 * Product-update / "What's new" metadata for the changelog notification.
 *
 * Bump CURRENT_PRODUCT_VERSION (and update TITLE/BODY) whenever there's a
 * release worth surfacing to existing users via an in-app notification. The
 * notify_product_update RPC is idempotent per (user, version), so re-bumping is
 * the trigger for a fresh notification; the same version never notifies twice.
 *
 * Version source mirrors src/lib/sentry.ts (VITE_APP_VERSION). We keep an
 * explicit product version string here too, because the changelog "what's new"
 * cadence is editorial (a human decides a release is notable) and is decoupled
 * from the build/package version used for error-tracking releases.
 */

export const CURRENT_PRODUCT_VERSION = 'v1.1';

export const PRODUCT_UPDATE_TITLE = `What's new in BuildIt ${CURRENT_PRODUCT_VERSION}`;

export const PRODUCT_UPDATE_BODY =
  'Notifications got an upgrade: real-time alerts, a "What\'s new" feed, and ' +
  'per-category notification preferences in Settings. See the full list of changes.';

/**
 * tour_id used in public.user_onboarding to record the last product-update
 * version a user has been notified about. Reuses the same last-seen-version
 * store as the onboarding tours (see useFoundationalTour).
 */
export const PRODUCT_UPDATE_TOUR_ID = 'product_update';
